import { FC ,memo} from "react";
import PendingTableRow from "./pendingTableRow";
import { NotTreatedData } from "src/pages/actionDashboard/types";
import NoDataFound from "src/components/noDataFoundComponent";

type Props = {
  data: NotTreatedData[];
  refreshListing: () => void;
  
};

const PendingTableBody: FC<Props> = ({ data, refreshListing }) => (
  <tbody className="position-relative">
    {data && data.length > 0 ?
      data.map((row, idx) => (
        <PendingTableRow
          row={row}
          refreshListing={refreshListing}
          index={idx}
        />
      )):<NoDataFound/>
      }
  </tbody>
);

export default memo(PendingTableBody);
